/**
 * File to manage Contexts
 * Prashant Bhatt <pbhatt@svb.com> (svb.com)
 *
 */
import { createContext } from 'react';

const ApiPageContext = createContext();
const SearchDataContext = createContext();
// const OtherPageContext = createContext('someDefaultValueForFallBackIfNeeded');
export {
  ApiPageContext,
  SearchDataContext,
  // OtherPageContext
};
